import React from 'react';
import { Heart, Shield } from '../icons';

function PrivacyPolicy() {
  return (
    <div style={{ minHeight: '100vh', background: '#fafafa' }}>
      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg, #DC143C 0%, #9b111e 100%)', color: '#fff', padding: '60px 24px', textAlign: 'center' }}>
        <Shield size={48} style={{ marginBottom: '16px', opacity: 0.9 }} />
        <h1 style={{ fontSize: '2.4rem', fontWeight: '800', margin: '0 0 12px' }}>Privacy Policy</h1>
        <p style={{ fontSize: '1.1rem', opacity: 0.85, margin: 0 }}>Effective Date: January 1, 2025 &nbsp;·&nbsp; Last Updated: May 1, 2026</p>
      </div>

      {/* Content */}
      <div style={{ maxWidth: '860px', margin: '0 auto', padding: '48px 24px 80px' }}>
        <div style={{ background: '#fff', borderRadius: '16px', padding: '40px 48px', boxShadow: '0 2px 16px rgba(0,0,0,0.07)' }}>

          <p style={{ color: '#374151', lineHeight: 1.8, fontSize: '1rem', marginBottom: '32px' }}>
            Welcome to <strong>NepWed</strong> ("we", "us", or "our"). We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit <strong>nepwed.com</strong> and use our wedding planning services.
          </p>

          <Section title="1. Information We Collect">
            <p>We collect information you provide directly to us when you:</p>
            <ul>
              <li>Create an account (name, email address, password)</li>
              <li>Set up your wedding profile (partner names, wedding date, venue, city, guest count)</li>
              <li>Add vendors, budget items, checklist tasks, or guest information</li>
              <li>Upload photos, videos, or documents</li>
              <li>Contact vendors through our platform or submit RSVP responses</li>
              <li>Communicate with our support team</li>
            </ul>
            <p>We also automatically collect certain technical information when you use our services, including IP address, browser type, device type, pages visited, and usage patterns — solely to improve our platform.</p>
          </Section>

          <Section title="2. How We Use Your Information">
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide, operate, and maintain our wedding planning tools</li>
              <li>Create and manage your account and wedding profile</li>
              <li>Connect you with wedding vendors and process inquiries</li>
              <li>Send you relevant notifications, reminders, and updates about your wedding planning</li>
              <li>Enable collaboration features with family members and co-planners</li>
              <li>Improve our platform features and user experience</li>
              <li>Respond to support requests and resolve disputes</li>
              <li>Comply with applicable laws and regulations in Nepal</li>
            </ul>
          </Section>

          <Section title="3. Information Sharing">
            <p>We do <strong>not</strong> sell, rent, or trade your personal information to third parties for marketing purposes. We may share your information only in the following limited circumstances:</p>
            <ul>
              <li><strong>With vendors you contact:</strong> When you submit an inquiry to a vendor, your name and message are shared with that vendor.</li>
              <li><strong>With collaborators you invite:</strong> Family members and co-planners you invite to your wedding profile may see your wedding details as permitted by your privacy settings.</li>
              <li><strong>For public wedding websites:</strong> If you publish your wedding website, the information on it will be visible to anyone with the link.</li>
              <li><strong>Service providers:</strong> We work with trusted third-party services (hosting, email delivery) that process data strictly on our behalf.</li>
              <li><strong>Legal requirements:</strong> We may disclose information when required by Nepali law or to protect the rights and safety of our users.</li>
            </ul>
          </Section>

          <Section title="4. Data Storage and Security">
            <p>Your data is stored on secure servers hosted in the cloud. We use industry-standard security measures including HTTPS encryption, secure password hashing, and access controls to protect your information.</p>
            <p>However, no method of transmission over the internet is 100% secure. While we strive to protect your personal data, we cannot guarantee its absolute security.</p>
          </Section>

          <Section title="5. Cookies">
            <p>We use cookies and similar tracking technologies to maintain your login session and improve your experience. You can control cookies through your browser settings; however, disabling cookies may affect the functionality of certain features.</p>
          </Section>

          <Section title="6. Your Rights">
            <p>You have the right to:</p>
            <ul>
              <li>Access the personal information we hold about you</li>
              <li>Correct inaccurate or incomplete information</li>
              <li>Delete your account and associated personal data</li>
              <li>Withdraw consent for optional data processing at any time</li>
              <li>Request a copy of your data in a portable format</li>
            </ul>
            <p>To exercise these rights, email us at <a href="mailto:contact@nepwed.com" style={{ color: '#DC143C' }}>contact@nepwed.com</a>.</p>
          </Section>

          <Section title="7. Children's Privacy">
            <p>NepWed is not directed to individuals under the age of 18. We do not knowingly collect personal information from minors. If you believe a minor has provided us with personal information, please contact us immediately.</p>
          </Section>

          <Section title="8. Third-Party Links">
            <p>Our platform may contain links to vendor websites and social media platforms. We are not responsible for the privacy practices of those third-party sites and encourage you to review their privacy policies independently.</p>
          </Section>

          <Section title="9. Changes to This Policy">
            <p>We may update this Privacy Policy from time to time. When we do, we will update the "Last Updated" date at the top of this page. Continued use of NepWed after changes are posted constitutes your acceptance of the revised policy.</p>
          </Section>

          <Section title="10. Contact Us">
            <p>If you have questions or concerns about this Privacy Policy or our data practices, please contact us:</p>
            <p>
              <strong>NepWed</strong><br />
              Durbar Marg, Kathmandu, Nepal<br />
              Email: <a href="mailto:contact@nepwed.com" style={{ color: '#DC143C' }}>contact@nepwed.com</a>
            </p>
          </Section>

          <div style={{ marginTop: '48px', padding: '24px', background: '#fdf2f8', borderRadius: '12px', textAlign: 'center', color: '#9d174d' }}>
            <Heart size={20} style={{ verticalAlign: 'middle', marginRight: '8px' }} />
            Thank you for trusting NepWed with your special day.
          </div>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '36px' }}>
      <h2 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#111827', marginBottom: '12px', paddingBottom: '8px', borderBottom: '2px solid #fce7f3' }}>{title}</h2>
      <div style={{ color: '#374151', lineHeight: 1.8, fontSize: '0.97rem' }}>
        {children}
      </div>
    </div>
  );
}

export default PrivacyPolicy;
